export const escapePostgrestQuotedValue = (value: string): string => value.replaceAll('"', '""');

export const buildPostgrestIlikePattern = (value: string): string =>
  `"*${escapePostgrestQuotedValue(value)}*"`;

export const buildPostgrestOrIlikeFilter = (fields: readonly string[], value: string): string => {
  const words = value.trim().split(/\s+/).filter(Boolean);
  if (words.length <= 1) {
    const pattern = buildPostgrestIlikePattern(value.trim());
    return `(${fields.map((field) => `${field}.ilike.${pattern}`).join(',')})`;
  }
  const fieldClauses = fields.map((field) => {
    const wordConditions = words.map((word) => `${field}.ilike.${buildPostgrestIlikePattern(word)}`);
    return `and(${wordConditions.join(',')})`;
  });
  return `(${fieldClauses.join(',')})`;
};

export const normalizePostgrestIlikeTemplate = (
  template?: string,
  placeholder = '{{value}}',
): string | undefined => {
  if (!template) {
    return template;
  }

  const legacyFragment = `ilike.*${placeholder}*`;
  const safeFragment = `ilike."*${placeholder}*"`;
  return template.split(legacyFragment).join(safeFragment);
};
